import { z } from "zod";

import { machineSchema } from "../machine";
import { trackWithOffsetSchema } from "../track";

const physicalMachineSettingsSchema = z.object({
	unit: z.string(),
});

export const emMachineSchema = machineSchema.extend({
	tracks: z.array(trackWithOffsetSchema),
	physicalMachineSettings: physicalMachineSettingsSchema,
	crossConveyorConnected: z.boolean().optional(),
	releaseBehavior: z.string().nullish(),
});

export type EmMachine = z.infer<typeof emMachineSchema>;
